import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Remove platform-injected badge from the DOM (and keep it removed)
const removeBadge = () => {
  const el = document.getElementById("emergent-badge");
  if (el && el.parentNode) el.parentNode.removeChild(el);
};
removeBadge();
if (typeof window !== "undefined") {
  const obs = new MutationObserver(removeBadge);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener("load", removeBadge);
  setInterval(removeBadge, 1500);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
